import CowsApi from '../../../api/cows-api';
import { mapState, mapActions } from 'vuex';
import i18n from '../../../plugins/i18n';
import { StatusTypes } from '../../../constants/status_types';
import UtilsService from '../../../services/UtilsService';

export default {
  name: 'CreateCowModal',

  props: { isModalOpen: Boolean, reload: Function },
  data() {
    return {
      isLoading: false,
      maxDate: this.$moment().format('YYYY-MM-DD'),

      name: null,
      fullEartag: null,
      breed: null,
      lactationNumber: null,
      selectedBarn: null,
      selectedBolus: null,
      state: null,
      isArchived: null,

      errors: {},
      serverError: null,

      date: null,
      lastCalving: null,
      lastInsemination: null
    };
  },
  computed: {
    ...mapState({
      boluses(state) {
        return [{ text: "Don't add bolus", value: "" }, ...state.boluses.boluses.map(d => ({
            value: d.bolus_id,
            text: d.bolus_name
          }))
        ];
      },
      barns(state) {
        return state.buildings.data.map(d => {
          return {
            value: d.building_id,
            text: d.building_name
          };
        });
      }
    }),
    states() {
      return Object.values(StatusTypes).filter(status => status != StatusTypes.States).map((status) => ({ code: status, name: i18n.t(`cowGenerics.cowLogs.${status}`) }));
    },
    formattedLastCalvingDate() {
      return this.lastCalving
        ? this.$moment(this.lastCalving).format('DD-MM-YYYY')
        : '';
    },
    formattedLastInseminationDate() {
      return this.lastInsemination
        ? this.$moment(this.lastInsemination).format('DD-MM-YYYY')
        : '';
    },
    formattedBirthDate() {
      return this.date ? this.$moment(this.date).format('DD-MM-YYYY') : '';
    }
  },

  methods: {
    ...mapActions('boluses', {
      clearBoluses: 'clear',
      listBoluses: 'listBoluses'
    }),
    ...mapActions('buildings', {
      clearBuildings: 'clear',
      getBarns: 'getBuildings'
    }),
    flushErrors() {
      this.serverError = null;
      this.errors = {};
    },
    validate() {
      this.flushErrors();

      if (this.name === null || this.name === '') {
        this.errors.name = i18n.t('editCow.errors.fieldRequired');
      }

      if (this.selectedBarn === null) {
        this.errors.barn = i18n.t('editCow.errors.barnRequired');
      }

      if (this.state === null) {
        this.errors.state = i18n.t('editCow.errors.fieldRequired');
      }

      // check if the date fields have no error
      if (this.$refs.pickerLastCalving.error ||
        this.$refs.pickerLastInsemination.error ||
        this.$refs.pickerBirthDate.error) {
        return false;
      }

      if (Object.keys(this.errors).length > 0) {
        return false;
      }
      return true;
    },
    async create() {
      // Validate form data before save
      const isValidForm = this.validate();
      if (!isValidForm) return;

      // Define the data to send
      const dataToSend = {
        eartag: this.name,
        ...(this.breed && {
          breed: this.breed
        }),
        ...(this.fullEartag && {
          full_eartag: this.fullEartag
        }),
        ...(this.lactationNumber && {
          lactation_number: parseInt(this.lactationNumber)
        }),
        building_id: this.selectedBarn,
        ...(this.selectedBolus && {
          bolus_id: this.selectedBolus
        }),
        status_type: this.state,
        ...(this.isArchived && {
          is_archived: true
        }),
        ...(this.date && {
          // We need only the date part, so we take out the timezone since it can shift the date by one day
          birth_date: UtilsService.getDate(new Date(this.date))
        }),
        ...(this.lastCalving && {
          last_calving: UtilsService.getDate(new Date(this.lastCalving))
        }),
        ...(this.lastInsemination && {
          last_insemination: UtilsService.getDate(new Date(this.lastInsemination))
        })
      };

      // Set loading and wait for data to be sent and response to be returned.
      const response = await CowsApi.createCow(dataToSend);

      if (response.data && response.status === 200) {
        this.reload();
        this.close();
      } else if (response.status === 400) {
        this.serverError = {
          error: response.data,
          message: response.data
        };
      } else {
        // already handled by axios
      }
    },
    close() {
      this.$emit('close');
    }
  },
  mounted() {
    this.listBoluses({ available_only: true });
    this.getBarns();
  }
};



// WEBPACK FOOTER //
// ./src/components/_modals/create-cow/create-cow-modal.js